import GeneralLayout from "./General"
import NavEngrave from "@/assets/imgs/nav-engrave.png"
import DiSanaHero from "@/pages/di-sana/components/Hero"
import { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useRef, useState } from "react"
import { useGlobalContext } from "@/global/GlobalContext"
import { getError } from "@/app/utils/helpers"
import { userDetailSchema } from "@/app/utils/validation"
import { useDispatch } from "react-redux"
import CryptoHelper from "@/app/utils/crypto";
import DiSanaAPI from "@/app/api/di-sana/di-sana"
import RegionsAPI from "@/app/api/customer-dashboard/regions";
import MyAccountAPI from "@/app/api/customer-dashboard/my-account";
import { updateUser } from "@/app/redux/features/auth/authSlice"
import { useNavigate } from "react-router-dom"
import ProcessModal from "@/components/ProcessModal"
import { loadOrderCount } from "@/app/redux/features/order/orderSlice";
import Cookies from "js-cookie"
const diSanaApi = new DiSanaAPI()
const cryptoHelper = new CryptoHelper()
const regionsApi = new RegionsAPI()
const myAccountApi = new MyAccountAPI()

const DefaultLayout = forwardRef(({ children, hasDiscoverLink = false, noHero = false, bgColor = "" }, ref) => {
  const {
    categories,
    setCategories,
    pathname,
    notifyError,
    authStore,
    setUserDetail,
    setRegions,
    setProductDetail,
    products,
    setProducts,
    setProductRecomms,
    setOnReqDiSana,
    setProductsPerPage,
    notifySuccess,
    setSeoContent } = useGlobalContext()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [tempCategories, setTempCategories] = useState([])
  const [modalContent, setModalContent] = useState(null)
  const [hideLoadMoreBtn, setHideLoadMoreBtn] = useState(true)
  const authData = authStore

  useImperativeHandle(ref, () => ({
    getUserDetail: async () => await loadUserDetail(),
    getDomDestinations: async (region) => await loadDomDestinations(region),
    getProductByProdCategory: async (id, page, loadMore, diff) => await loadProductByProdCategory(id, page, loadMore, diff),
    getProductDetail: async (s) => await loadProductDetail(s),
    handleUpdateUser: async (formData) => await updateUserDetail(formData),
    getHideLoadMoreBtn: () => handleHideLoadMoreBtn(),
  }))

  useEffect(() => {
    if (pathname.includes("di-sana") && categories.length == 0) loadAllProductCategories()
  }, [])

  useEffect(() => {
    if (authData && authData.token && authData.user) {
      const fetchData = async () => await getOrderCount()

      fetchData()
    }
  }, [authData])

  const getOrderCount = async () => {
    try {
      await dispatch(loadOrderCount()).unwrap()
    } catch (err) {
      notifyError(err)
    }
  }

  const handleHideLoadMoreBtn = () => {
    return hideLoadMoreBtn
  }

  const handleOnReq = () => {
    return onReq
  }

  useLayoutEffect(() => {
    if (tempCategories.length > 0) addSlugToCategories()
  }, [tempCategories])

  const addSlugToCategories = () => {
    let tempCategoriesWithSlug = tempCategories.map((val) => ({ name: val.name, slug: val.name.replaceAll(" ", "-").toLowerCase(), photo: val.photo }))
    tempCategoriesWithSlug.push({ name: "Loro Blonyo Fine Porcelain", slug: "loro-blonyo-fine-porcelain", photo: "" })

    // setCategories(tempCategories.map((val) => ({ ...val, slug: val.name.replaceAll(" ", "-").toLowerCase() })))
    setCategories(tempCategoriesWithSlug.sort((a, b) => a.name.localeCompare(b.name)))
  }

  // API request
  const loadAllProductCategories = async () => {
    setOnReqDiSana(true)
    try {
      let params = {
        sortby: "name",
        direction: "asc"
      }
      const { data } = await diSanaApi.getAllProductCategories(params)
      setTempCategories(data.data)
    } catch (err) {
      notifyError(err.message)
    }
    setOnReqDiSana(false)
  }

  const loadProductByProdCategory = async (id, page, loadMore = false, diff = false) => {
    try {
      if (diff) Cookies.set("categoryId", id)
      const storeCategoryId = Cookies.get("categoryId")
      const productsPage = Cookies.get("productsPage")
      let tempPage = 1
      if (!productsPage) {
        Cookies.set("productsPage", 1)
      } else {
        tempPage = productsPage
      }
      let params = {
        categoryId: storeCategoryId,
        page: page ? page : tempPage
      }

      const { data } = await diSanaApi.getProductByProdCategory(params)
      if (diff) {
        setHideLoadMoreBtn(data.data.length < 6)
        setProducts(data.data)
        setProductRecomms(data.data)
      } else {
        setHideLoadMoreBtn(data.data.length < 6)
        if (data.data.length > 0) setProductsPerPage(data.data)
        if (products.length > 0 && loadMore) {
          setProducts(products.concat(data.data))
        } else {
          setProducts(data.data)
        }
      }
    } catch (err) {
      notifyError(err.message)
    }
  }

  const loadProductDetail = async (slug) => {
    try {
      const { data } = await diSanaApi.getProductDetails(slug)
      setProductDetail(data.data);
      // setSeoContent({
      //   name: data.data.name,
      //   description: data.data.description,
      //   image: data.data.photo
      // })
      if (!Cookies.get("productId") || (Cookies.get("productId") != data.data.id)) {
        Cookies.set("productId", data.data.id)
      }
    } catch (err) {
      notifyError(err.message)
    }
  }

  const loadUserDetail = async () => {
    try {
      const { data } = await myAccountApi.getUserDetail()
      setUserDetail(data.data)
    } catch (err) {
      notifyError(err.message)
    }
  }

  const loadAllProvinces = async () => {
    try {
      const { data } = await regionsApi.getAllProvinces()
      setProvinces(data)
    } catch (err) {
      notifyError(err.message)
    }
  }

  const loadAllRegencies = async (country, province) => {
    try {
      let params = {
        ciso: country,
        siso: province
      }
      const { data } = await regionsApi.getAllRegencies(params)
      setCities(data)
    } catch (err) {
      notifyError(err.message)
    }
  }

  const loadDomDestinations = async (region) => {
    try {
      let param = {
        search: region,
        destination_type: ""
      }

      const { data } = await regionsApi.getDomDestinations(param)
      if (data.data.regions.length <= 0) {
        param = { ...param, destination_type: "api" }

        const data2 = await regionsApi.getDomDestinations(param)
        setRegions(data2.data.data.regions)
      } else {
        setRegions(data.data.regions)
      }
    } catch (err) {
      notifyError(err.message)
      setRegions([])
    }
  }

  const updateUserDetail = async (formData) => {
    try {
      const insertedData = userDetailSchema.safeParse({
        id: formData.id,
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        // for ro destination
        ro_destination_id: formData.ro_destination_id,
      })

      if (!insertedData.success) return { error: insertedData.error.issues }

      const res = await dispatch(updateUser(insertedData.data)).unwrap()
      if (res.code == 200) {
        const encryptedUser = cryptoHelper.encrypt(JSON.stringify({ id: res.data.id, name: res.data.name }))
        Cookies.set("user", encryptedUser, {
          // expires: 30,
          secure: true,
          sameSite: "Strict"
        })

        notifySuccess("Your changes has been saved.")
      }
    } catch (err) {
      return getError(err)
    }
  }

  return (
    <>
      <ProcessModal pModalContent={modalContent} />
      <GeneralLayout bgColor={bgColor ? bgColor : "bg-transparent"} hasGreekL={!!noHero} contentColor="text-[#95702e]" relativeCls={!noHero && "relative -top-[50px]"} isFixed={!noHero}>
        {/* for di sana pages */}
        {!noHero && hasDiscoverLink ? (
          <DiSanaHero>
            <div className="mt-10 text-center">
              <a href="#diSanaCategories" className="font-agcasmlt uppercase text-sm sm:text-xl text-[#6b6059]">discover di sana</a>
              <img img="100" src={NavEngrave} className="w-20 -mt-1 mx-auto" />
            </div>
          </DiSanaHero>
        ) : (
          <>
            {!noHero && (
              <DiSanaHero />
            )}
          </>
        )}
        {/* for general pages */}
        {children}
      </GeneralLayout>
    </>
  )
})

export default DefaultLayout